import React, { useState } from 'react';
import { Heading, Spinner } from '../components/common/atoms'
import OTP from '../components/common/templates/Login/OTP'
import { appApi } from '../services';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { successOrFailureToaster } from '../components/common/atoms/messages';

const SettingsOTPPage = () => {
  const history = useHistory()
  const [isLoading, setLoading] = useState(false)

  const requestAuth = async (code) => {
    setLoading(true)
    let options = { data: { otp_code: code }}

      await appApi.mfaCreate(options,
        (res)=> {
            let msg = res?.data?.message
            successOrFailureToaster({message: msg})
            history.push({pathname: 'mfa-backup-code', state: res.data})
            setLoading(false)
        },
        (e)=>{
          let msg = e?.response?.data?.message
          successOrFailureToaster({message: msg, type: 'fail'})
          setLoading(false)
        });
  }

  const resendOtp = async () => {
    setLoading(true)    
    await appApi.mfaOTPAuth({}, 
      (res) => {
        let msg = res?.data?.message
        successOrFailureToaster({message: msg})
        setLoading(false)
      },
      (e) => {
        successOrFailureToaster({message: 'Something went wrong!', type: 'fail'})
        setLoading(false)
      })
  }

  return (
    <Spinner visible={isLoading}>
      <div>
        <Heading mainHeading='Account Settings' subClasses='mt-1 text-sm text-gray-600' />
      </div>
      <div className='rounded-md shadow-md my-4 bg-white px-4 py-4' style={{ width: '26rem' }}>
        <OTP requestAuth={requestAuth} resend_otp={resendOtp} />
      </div>
    </Spinner>
  )
}

export default SettingsOTPPage